import { render, staticRenderFns } from "./PageUserNotifications.vue?vue&type=template&id=40efeb6c"
import script from "./PageUserNotifications.vue?vue&type=script&lang=js"
export * from "./PageUserNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports